import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => (
  {
    root: {
      left: '50%',
      top: '50%',
      position: 'absolute',
    },
  }
));

export default useStyles;
